import axios from "axios";

export default {
    async getProdotti() {
        const data = new FormData();
        data.append("orderby", "fw_products_name");
        data.append("orderdir", "asc");

        const response = await axios.post("rest/v1/search/fw_products", data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        //console.log(response.data.data);
        return response.data;
    },

    async searchProductByBarcode(barcode) {
        const data = new FormData();
        data.append("where[]", "(fw_products_barcode LIKE '%" + barcode + "%' OR fw_products_sku LIKE '%" + barcode + "%')");
        data.append("orderby", "fw_products_name");
        data.append("orderdir", "asc");

        const response = await axios.post("rest/v1/search/fw_products", data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        console.log(response);
        return response;
    },
};
